module.exports = __webpack_public_path__ + "img/11069867_L.271d311f.png";